export default __webpack_public_path__ + "112b3cbe49e574350e42e92819657a08.png";